//updated by dolphin on 9/23/2021, 3:24:41 PM.

"use strict";
const API = {
  commonCondition: {
    default0: {IS_DEFAULT: 0},
    'S_SYS_TYPE_20011002': {'S.SYS_TYPE': 20011002,},
    'S_SYS_TYPE_20011003': {'S.SYS_TYPE': 20011003,},
    'S_SYS_TYPE_not_20011003': {'S.SYS_TYPE_not': 20011003,}, //企业类型不是货方
  },
  baseCode: {
    '10000004': {TYPE_ID: '10000004',IS_VISIBLE: 1,STATUS: 1},
    '10000011': {TYPE_ID:'10000011',IS_VISIBLE: 1,STATUS: 1},
    '10000013': {TYPE_ID:'10000013',IS_VISIBLE: 1,STATUS: 1},
    '10000010': {TYPE_ID:'10000010',IS_VISIBLE: 1,STATUS: 1},
    '10000006': {TYPE_ID:'10000006',STATUS: 1},
    '10000001': {TYPE_ID:'10000001',IS_VISIBLE: 1,STATUS: 1},
    '10000005': {TYPE_ID:'10000005',IS_VISIBLE: 1,STATUS: 1}
  },
  role: {
    'external_Not10000005' : {ROLE_TYPE:'20001002',ROLE_ID_not:'10000005'},
    '20001001' : {ROLE_TYPE:'20001001'}
  },
  dict: {
    '2005': {DIC_TYPE:'2005'},
    '2009': {DIC_TYPE:'2009'},
    '2024': {DIC_TYPE:'2024'},
    '2001': {DIC_TYPE:'2001'},
    '1007': {DIC_TYPE:'1007'},
    '2013': {DIC_TYPE:'2013'},
    '2023': {DIC_TYPE:'2023'},
    '2000': {DIC_TYPE:'2000'},
    '2032': {DIC_TYPE:'2032'},
    '2033': {DIC_TYPE:'2033'},
    '2029': {DIC_TYPE:'2029'},
    '2010': {DIC_TYPE:'2010'},
    '2022': {DIC_TYPE:'2022'},
    '2043': {DIC_TYPE:'2043'},
    '2001_CODE_NOT_20011004': {DIC_TYPE:'2001',DIC_CODE_not: '20011004'},
    '2001_CODE_NOT_20011001': {DIC_TYPE:'2001',DIC_CODE_not: '20011001'},
    '2001_CODE_NOT_20011004_ID_NOT_10000132': {DIC_TYPE:'2001',DIC_CODE_not: '20011004',DIC_ID_not: '10000132'}
  }
};

export default API
